const policyIssuanceAction = {
    BEGIN_ISSUANCE : 'begin issuance',

    REVERT_TO_BOUND : 'revert to bound',

    SUBMIT_FOR_ISSUANCE : 'submit for issuance',

    MODIFY_ISSUANCE : 'modify issuance',

    MARK_AS_ISSUED : 'mark as issued',

    REVERT_TO_PENDING_ISSUANCE : 'revert to pending issuance'

};

angular.module('gw-um-j2js')
    .constant('policyIssuanceAction', policyIssuanceAction);